export const stage = process.env.REACT_APP_STAGE;

export const isStageLocal = stage === 'local';